<form  autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button [disabled]="!habilitarGuardar" class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Documento </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Documentos {{refAtestFito}} </h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtest}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudAtest}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtest}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudAtestFito.IdEstado | IconoEstadoSolicitudAtest}}" ngbTooltip="{{solicitudAtestFito.IdEstadoDescripcion}}" />

            </span>
        </h5>
        <!--DOCUMENTOS-->
        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">

                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Documentos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="solicitudAtestFito.TDocumentoSolicitudAtestFitoCollection"
                                 [columns]="cols" sortField="Fecha" sortOrder="-1"
                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                 [ngClass]="displayGridHidden(solicitudAtestFito.TDocumentoSolicitudAtestFitoCollection)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='Fecha'">
                                            {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                        </span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <div *ngIf="documentoDescargable">
                                                <button (click)="onDownload(rowData)" type="button" title="Descargar documento"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                            </div>
                                            <div *ngIf="documentoEditable">
                                                <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>
                                                </button>
                                            </div>
                                            <div *ngIf="!documentoEditable">
                                                <button (click)="onEdit(rowData)" type="button" title="Ver"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>
                                                </button>
                                            </div>
                                            <div *ngIf="documentoBorrable">
                                                <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                            No hay documentos asociados a la atestación
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>

</form>
